<button mat-icon-button class="close-button" [mat-dialog-close]="true">
  <mat-icon class="close-icon" color="warn">close</mat-icon>
</button>
<yt-player [videoId]="'CEBCOOpmLNY'" [options]="option"></yt-player>